import { twMerge } from 'tailwind-merge';
import { ClassValue, clsx } from 'clsx';

export type { ClassValue };

export function mergeClasses(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function transform(value: boolean | string): boolean {
  return typeof value === 'string' ? value === '' : value;
}

export function generateId(prefix = ''): string {
  const id = crypto.randomUUID();
  return prefix ? `${prefix}-${id}` : id;
}

/**
 * A no-operation function for use as a default callback in Zard components.
 * Accepts any arguments and returns void.
 * Used to provide sensible defaults for event/callback type signatures.
 */
export function noopFun(..._args: unknown[]): void {
  // no operation performed
}